import React, { useEffect, useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton, Typography } from "@mui/material";
import { Close as IconClose } from "@mui/icons-material";

import ReceiptPayment from "../containers/Receipt/Payment";
import { PaperComponentDraggable } from "./common/PaperComponentDraggable";

// Registro del pago de un comprobante dentro de un dialogo.
//
// Se usa desde la navegabilidad de los periodos de terapia: el link "Pagar" de
// la columna Est. Pago abre esta ventana con los items del comprobante (el
// cobro que se esta pagando) y sus pagos. Al registrar se avisa a la pantalla
// que lo abrio para que refresque el listado.
const ComprobantePagoDialogo = ({ open, idComprobante, onClose, onSaved }) => {
    // Se reinicia al abrir: cada pago parte de la lista de pagos del comprobante.
    const [clave, setClave] = useState(0);

    useEffect(() => {
        if (open) setClave((previo) => previo + 1);
    }, [open]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="lg" PaperComponent={PaperComponentDraggable}>
            <DialogTitle id="draggable-dialog-title" style={{ cursor: "move" }}>
                <Grid alignItems="center" container spacing={1}>
                    <Grid item xs={10} sm={10}>
                        <Typography variant="h6" sx={{ fontWeight: "bold" }}>
                            {"Cobranza y Detalle de Pagos"}
                        </Typography>
                    </Grid>
                    <Grid item xs={2} sm={2} display="flex" justifyContent="flex-end">
                        <IconButton aria-label="cerrar" size="small" onClick={onClose}>
                            <IconClose fontSize="small" />
                        </IconButton>
                    </Grid>
                </Grid>
            </DialogTitle>

            <DialogContent dividers>
                {/* La clave cambia en cada apertura para que el formulario se
                    reinicie y no herede el pago anterior. */}
                <ReceiptPayment
                    key={clave}
                    idComprobante={idComprobante}
                    enDialogo={true}
                    onSaved={(idGuardado) => {
                        if (onSaved) onSaved(idGuardado);
                    }}
                />
            </DialogContent>

            <DialogActions>
                <Button variant="outlined" onClick={onClose}>{"Cerrar"}</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ComprobantePagoDialogo;
